import { createSelector } from '@ngrx/store';

import { selectConsentState } from '../consent.state';

export const selectPackageView = createSelector(
  selectConsentState,
  (state) => state.packageView
);
